import { createSlice } from "@reduxjs/toolkit";

export interface OtpState {
  email: string;
  isVerified: boolean;
}

const getOtpState = () => {
  const otpState = JSON.parse(localStorage.getItem("otpState")) as OtpState;

  return otpState ?? { email: "", isVerified: false };
};

const otpSlice = createSlice({
  name: "otp",
  initialState: getOtpState(),
  reducers: {
    saveEmailVerified(state, action) {
      localStorage.setItem("otpState", JSON.stringify(action.payload));
      state.email = action.payload.email;
      state.isVerified = action.payload.isVerified;
    },
  },
});

export const { saveEmailVerified } = otpSlice.actions;
export default otpSlice.reducer;
